/**
 * Where the business works (Lubbock), for the days no phone dates: a visit
 * started by a desk edit, a connected assistant or a build from before
 * visits, and a change to the site record made with no visit open. A phone
 * dates its own visits by its own clock. In UTC, an evening's desk edit would
 * be dated tomorrow, and outrank the visit a phone starts today.
 *
 * The web app uses the same zone for "today" on season reminders and for the
 * calendar year of a meeting date. The daily reminder schedule runs at 8:00
 * in this zone. One constant, so those three cannot drift apart.
 */
export const BUSINESS_TIME_ZONE = 'America/Chicago' as const

/** Today where the business works, `YYYY-MM-DD`. */
export function businessToday(now: Date = new Date()): string {
  // en-CA writes a date as YYYY-MM-DD.
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: BUSINESS_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(now)
}
